<template>
  <article class="line-center relative flex pb-12 md:px-5 md:pb-[initial]">
    <div
      class="timeline-img-box flex h-[calc(50%-24px)] w-full max-w-[136px] items-center md:max-w-[initial]"
    >
      <NuxtLink :to="`${getCardSettings(items).hrefBase}${items?.slug}`">
        <div
          class="size-full max-h-[120px] min-h-[120px] min-w-[120px] max-w-[120px] overflow-hidden rounded-50% border-2 border-ruby-red-100 md:max-h-[140px] md:min-h-[140px] md:min-w-[140px] md:max-w-[140px] md:border-4"
        >
          <img
            v-lazy-load
            :src="getSrc"
            alt=""
            class="size-full min-h-[120px] object-cover"
          /></div
      ></NuxtLink>
      <div class="h-[2px] w-[16px] bg-ruby-red-100 md:h-full md:w-[4px]"></div>
    </div>
    <div
      class="grid size-full max-w-[12px] place-items-center pt-[57px] md:h-[48px] md:w-full md:max-w-[initial] md:pt-[initial]"
    >
      <div
        class="z-20 size-[6px] rounded-50% bg-white-100 md:size-[16px]"
      ></div>
    </div>
    <div class="ml-3 h-[calc(50%-48px)] md:ml-0 md:mt-4">
      <template v-if="items">
        <NuxtLink
          :to="`${getCardSettings(items).hrefBase}${items.slug}`"
          class="item-link flex flex-col md:items-center"
        >
          <div
            class="z-10 mb-1 font-times text-[32px] leading-[29px] text-ruby-red-100 md:mb-3 xl:text-[48px] xl:leading-[43px]"
          >
            {{ getDate }}
          </div>
          <div
            class="z-10 mb-1 font-roboto text-[16px] font-medium leading-[21px] md:mb-2 md:text-center xl:text-[20px] xl:leading-[26px]"
            style="
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            "
          >
            {{ items.title }}
          </div>
          <div
            class="z-10 font-roboto text-[12px] leading-[14px] md:mb-4 md:text-center md:text-[14px] md:leading-[17px]"
            style="
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
            "
          >
            {{ items.announce }}
          </div></NuxtLink
        >
      </template>
      <template v-else>
        <div
          class="text-smaller flex h-full items-center justify-center font-normal normal-case text-black-32"
        >
          Нет данных
        </div>
      </template>
    </div>
  </article>
</template>

<script setup>
const props = defineProps({
  // month: {
  //   type: Number,
  //   default: 1,
  // },

  items: {
    type: Object,
    default: () => ({}),
  },

  // isTimeline: {
  //   type: Boolean,
  //   default: false,
  // },
});
const getCardSettings = useCardSettings();
// const currentItemIndex = ref(0);

const getDate = computed(() => {
  return props.items.date?.split('-')[0] < 1000
    ? props.items.date?.split('-')[0].slice(1, 4)
    : props.items.date?.split('-')[0];
});

const getSrc = computed(() => {
  const src =
    props.items?.image && props.items.image?.preview
      ? props.items.image.preview
      : null;
  return src;
});
</script>

<style lang="scss">
.line-center {
  @apply md:flex-col before:h-full md:before:h-[48px] before:w-[12px] md:before:w-[101%] before:bg-ruby-red-100 before:absolute before:left-[136px] md:before:top-[50%] md:before:translate-y-[-50%] md:before:left-0 md:before:right-0;
}
.reverse-card.line-center {
  @apply flex-col-reverse;
}
.line-center .timeline-img-box {
  @apply md:flex-col;
}
.reverse-card.line-center .timeline-img-box {
  @apply flex-col-reverse;
}
.line-center.line-first {
  @apply before:rounded-t-[80px] md:before:rounded-t-[initial] md:before:rounded-l-[80px];
}
.line-center.line-last {
  @apply before:rounded-b-[80px] md:before:w-full md:before:rounded-b-[initial] md:before:rounded-r-[80px];
}
.reverse-card .item-link {
  @apply md:mt-[-24px] xl:mt-[initial];
}
</style>
